export default __webpack_public_path__ + "static/media/wstEth.98c8ac77.webp";